import { useState, useEffect } from "react";
import { loadAdminDashboard } from "../../api";

export default function useDashboardFilters({
  dashboard: initialDashboard,
  filters: initialFilters
}) {
  useEffect(() => {
    const req = async () => {
      const res = await loadAdminDashboard(initialDashboard.id);
      const { data } = await res.json();
      setDropDownOptions(data.filters);
    };

    req();
  }, [initialDashboard.id]);

  const [dropDownOptions, setDropDownOptions] = useState(null);
  const [dashboard, setDashboard] = useState(initialDashboard);
  const [filters, setFilters] = useState(
    initialFilters.map(f => ({ label: f.name, value: f.id }))
  );

  return [dropDownOptions, dashboard, filters, setFilters, setDashboard];
}
